// import React, { useState, useEffect } from "react";
// import axios from 'axios';
// import Select from "react-select";


// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const RegistrationFormnew = () => {

//     const [formData, setFormData] = useState({
//         name: "",
//         mobile: "",
//         gender: "",
//         type: "",
//         category: [],
//         isEducation: "0", // Default to 0 (No selection)
//         education: "",
//         experience: "",
//         email: "",
//         doorNumber: "",
//         street: "",
//         place: "",
//         district: "",
//         city: "",
//         pincode: "",
//         otherDetails: "",
//         webLinks: "",
//         youtubeLinks: "",
//         facebookLinks: "",
//         dnd: "",
//         image1: "",
//         image2: "",
//         idProof: "",
//         addressProof: "",
//         otherProof: "",
//       });
    
//       const [categories, setCategories] = useState([]);
//       const [districts, setDistricts] = useState([]);
//       const [cities, setCities] = useState([]);
//       const [loading, setLoading] = useState({ categories: false, cities: false });
//       const [searchData, setSearchData] = useState(null);
      
    
//       // Fetch categories based on selected type
//       useEffect(() => {
//         const fetchCategoriesByType = async () => {
//           if (!formData.type) {
//             setCategories([]);
//             return;
//           }
//           setLoading((prev) => ({ ...prev, categories: true }));
//           try {
//             const response = await fetch(`${API_BASE_URL}/categories?type=${formData.type}`);
//             if (response.ok) {
//               const data = await response.json();
//               setCategories(
//                 data.map((item) => ({
//                   value: item.id,
//                   label: item.category,
//                 }))
//               );
//             } else {
//               console.error("Failed to fetch categories");
//             }
//           } catch (err) {
//             console.error("Error fetching categories:", err);
//           } finally {
//             setLoading((prev) => ({ ...prev, categories: false }));
//           }
//         };
//         fetchCategoriesByType();
//       }, [formData.type]);
    
//       // Fetch districts
//       useEffect(() => {
//         const fetchDistricts = async () => {
//           try {
//             const response = await fetch(`${API_BASE_URL}/districts`);
//             if (response.ok) {
//               const data = await response.json();
//               setDistricts(data);
//             } else {
//               console.error("Failed to fetch districts");
//             }
//           } catch (err) {
//             console.error("Error fetching districts:", err);
//           }
//         };
//         fetchDistricts();
//       }, []);
    


//        // Handle file uploads
//   const handleFileChange = (e) => {
//     const { name, files } = e.target;
//     setFormData({ ...formData, [name]: files[0] });
//   };


//   const handleSearch = async (e) => {
//     e.preventDefault();
//     const mobile = e.target.searchMobile.value; // Get mobile number from the input
//     const type = e.target.searchType.value; // Get type from the select

//     if (!mobile || !type) {
//         alert("Please enter both mobile number and type.");
//         return;
//     }

//     try {
//         const response = await fetch(`${API_BASE_URL}/search_user_new?mobile=${mobile}&type=${type}`);
//         if (response.ok) {
//             const data = await response.json();
//             setSearchData(data); // Set the fetched data to state

//             // Fetch the cities based on the district ID
//             const cityResponse = await fetch(`${API_BASE_URL}/cities?districtId=${data.district}`);
//             if (cityResponse.ok) {
//                 const cities = await cityResponse.json();
//                 const selectedCity = cities.find(city => city.id === data.city); // Find the city by ID

//                 setFormData({
                  
//                     name: data.name,
//                     mobile: data.mobileno,
//                     gender: data.gender,
//                     type: data.type,
//                     category: data.category,
//                     isEducation: data.is_education.toString(), // Convert to string if needed
//                     education: data.education,
//                     experience: data.experience,
//                     email: data.email,
//                     doorNumber: data.door_no,
//                     street: data.street,
//                     place: data.place_name,
//                     district: data.district,
//                     city: selectedCity ? selectedCity.id : "", // Set the city ID
//                     pincode: data.pincode,
//                     otherDetails: data.other_details,
//                     webLinks: data.web_links,
//                     youtubeLinks: data.youtube_links,
//                     facebookLinks: data.fb_links,
//                     dnd: data.is_dnd ? "Yes" : "No", // Convert to string if needed
//                     image1: data.photo, // Set the image path
//                     image2: data.other_photo, // Set the other image path
//                     idProof: data.id_proof, // Set the ID proof path
//                     addressProof: data.address_proof, // Set the address proof path
//                     otherProof: data.other_proof, // Set the other proof path
//                 });

//                 // Set the cities in state to populate the dropdown
//                 setCities(cities);
//             } else {
//                 console.error("Failed to fetch cities");
//             }
//         } else {
//             console.error("Failed to fetch user data");
//             alert("No user found with this mobile number and type.");
//         }
//     } catch (err) {
//         console.error("Error fetching user data:", err);
//         alert("An error occurred while fetching user data.");
//     }
// };

//       // Fetch cities based on district
//       const handleDistrictChange = async (e) => {
//         const districtId = e.target.value;
//         setFormData({ ...formData, district: districtId, city: "" });
//         setLoading((prev) => ({ ...prev, cities: true }));
    
//         try {
//           const response = await fetch(`${API_BASE_URL}/cities?districtId=${districtId}`);
//           if (response.ok) {
//             const data = await response.json();
//             setCities(data);
//           } else {
//             console.error("Failed to fetch cities");
//           }
//         } catch (err) {
//           console.error("Error fetching cities:", err);
//         } finally {
//           setLoading((prev) => ({ ...prev, cities: false }));
//         }
//       };


//     //   const handleSubmit = async (e) => {
//     //     e.preventDefault();
    
//     //     const formDataToSend = new FormData();
//     //     Object.keys(formData).forEach((key) => {
//     //         if (key === "category") {
//     //             // Check if formData.category is an array before calling join
//     //             if (Array.isArray(formData[key])) {
//     //                 formDataToSend.append(key, formData[key].join(","));
//     //             } else {
//     //                 // If it's not an array, handle it accordingly (e.g., set it to an empty string)
//     //                 formDataToSend.append(key, "");
//     //             }
//     //         } else if (formData[key] instanceof File) {
//     //             formDataToSend.append(key, formData[key]);
//     //         } else {
//     //             formDataToSend.append(key, formData[key]);
//     //         }
//     //     });
    
//     //     try {
//     //         // Check if the user already exists
//     //         const searchResponse = await fetch(`${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${formData.type}`);
            
//     //         if (searchResponse.ok) {
//     //             // User exists, perform update
//     //             const updateResponse = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
//     //                 headers: { "Content-Type": "multipart/form-data" },
//     //             });
    
//     //             if (updateResponse.status === 200) {
//     //                 alert("User  updated successfully!");
//     //                 window.location.reload();
//     //             }
//     //         } else {
//     //             // User does not exist, perform insert
//     //             const insertResponse = await axios.post(`${API_BASE_URL}/register_newuser`, formDataToSend, {
//     //                 headers: { "Content-Type": "multipart/form-data" },
//     //             });
    
//     //             if (insertResponse.status === 200) {
//     //                 alert("Registration successful!");
//     //                 window.location.reload();
//     //             }
//     //         }
//     //     } catch (err) {
//     //         console.error("Error submitting form:", err);
//     //         if (err.response && err.response.status === 400) {
//     //             alert("User  with this mobile number and type already exists!");
//     //         } else {
//     //             alert("An error occurred. Please try again.");
//     //         }
//     //     }
//     // };
    
    
//       // Handle form input changes
     
     
     
//     //   const handleSubmit = async (e) => {
//     //     e.preventDefault();
    
//     //     const formDataToSend = new FormData();
//     //     Object.keys(formData).forEach((key) => {
//     //         if (key === "category" && Array.isArray(formData[key])) {
//     //             formDataToSend.append(key, formData[key].join(","));
//     //         } else if (formData[key] instanceof File) {
//     //             formDataToSend.append(key, formData[key]);
//     //         } else {
//     //             formDataToSend.append(key, formData[key]);
//     //         }
//     //     });
    
//     //     try {
//     //         let uploadedImage1 = "";
//     //         let uploadedImage2 = "";
    
//     //         // Upload images to external API
//     //         if (formData.image1 || formData.image2) {
//     //             const uploadData = new FormData();
//     //             uploadData.append("action", "img_upload");
//     //             if (formData.image1) uploadData.append("image", formData.image1);
//     //             if (formData.image2) uploadData.append("other_image", formData.image2);
    
//     //             const uploadResponse = await axios.post("https://nithra.mobi/calendar/services/api/img_upload.php", uploadData, {
//     //                 headers: { "Content-Type": "multipart/form-data" },
//     //             });
    
//     //             if (uploadResponse.status === 200 && uploadResponse.data) {
//     //                 uploadedImage1 = uploadResponse.data.image_url || "";
//     //                 uploadedImage2 = uploadResponse.data.other_image_url || "";
//     //             }
//     //         }
    
//     //         // Add uploaded image URLs to form data
//     //         formDataToSend.append("image1", uploadedImage1);
//     //         formDataToSend.append("image2", uploadedImage2);
    
//     //         // Check if the user already exists
//     //         const searchResponse = await fetch(`${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${formData.type}`);
    
//     //         if (searchResponse.ok) {
//     //             // User exists, perform update
//     //             const updateResponse = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
//     //                 headers: { "Content-Type": "multipart/form-data" },
//     //             });
    
//     //             if (updateResponse.status === 200) {
//     //                 alert("User updated successfully!");
//     //                 window.location.reload();
//     //             }
//     //         } else {
//     //             // User does not exist, perform insert
//     //             const insertResponse = await axios.post(`${API_BASE_URL}/register_newuser`, formDataToSend, {
//     //                 headers: { "Content-Type": "multipart/form-data" },
//     //             });
    
//     //             if (insertResponse.status === 200) {
//     //                 alert("Registration successful!");
//     //                 window.location.reload();
//     //             }
//     //         }
//     //     } catch (err) {
//     //         console.error("Error submitting form:", err);
//     //         alert("An error occurred. Please try again.");
//     //     }
//     // };


//   //   const handleSubmit = async (e) => {
//   //     e.preventDefault();
  
//   //     const formDataToSend = new FormData();
//   //     Object.keys(formData).forEach((key) => {
//   //         if (key === "category" && Array.isArray(formData[key])) {
//   //             formDataToSend.append(key, formData[key].join(","));
//   //         } else if (formData[key] instanceof File) {
//   //             formDataToSend.append(key, formData[key]);
//   //         } else {
//   //             formDataToSend.append(key, formData[key]);
//   //         }
//   //     });
  
//   //     try {
//   //         let uploadedImage1 = "";
//   //         let uploadedImage2 = "";
  
//   //         // Upload images to external API
//   //         if (formData.image1 || formData.image2) {
//   //             const uploadData = new FormData();
//   //             uploadData.append("action", "img_upload");
//   //             if (formData.image1) uploadData.append("image", formData.image1);
//   //             if (formData.image2) uploadData.append("other_image", formData.image2);
  
//   //             const uploadResponse = await axios.post("https://nithra.mobi/calendar/services/api/img_upload.php", uploadData, {
//   //                 headers: { "Content-Type": "multipart/form-data" },
//   //             });
  
//   //             console.log("Upload Response:", uploadResponse.data);
  
//   //             if (uploadResponse.status === 200 && uploadResponse.data) {
//   //                 uploadedImage1 = uploadResponse.data.image_url || "";
//   //                 uploadedImage2 = uploadResponse.data.other_image_url || "";
//   //             }
//   //         }
  
//   //         // Add uploaded image URLs to form data
//   //         formDataToSend.append("image1", uploadedImage1);
//   //         formDataToSend.append("image2", uploadedImage2);
  
//   //         // Log final form data
//   //         for (let pair of formDataToSend.entries()) {
//   //             console.log(pair[0] + ', ' + pair[1]);
//   //         }
  
//   //         // Check if the user already exists
//   //         const searchResponse = await fetch(`${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${formData.type}`);
  
//   //         if (searchResponse.ok) {
//   //             // User exists, perform update
//   //             const updateResponse = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
//   //                 headers: { "Content-Type": "multipart/form-data" },
//   //             });
  
//   //             if (updateResponse.status === 200) {
//   //                 alert("User updated successfully!");
//   //                 window.location.reload();
//   //             }
//   //         } else {
//   //             // User does not exist, perform insert
//   //             const insertResponse = await axios.post(`${API_BASE_URL}/register_newuser`, formDataToSend, {
//   //                 headers: { "Content-Type": "multipart/form-data" },
//   //             });
  
//   //             if (insertResponse.status === 200) {
//   //                 alert("Registration successful!");
//   //                 window.location.reload();
//   //             }
//   //         }
//   //     } catch (err) {
//   //         console.error("Error submitting form:", err);
//   //         alert("An error occurred. Please try again.");
//   //     }
//   // };


// //   const handleSubmit = async (e) => {
// //     e.preventDefault();


// //     // Log formData to check user_id
// //     console.log("Form Data:", formData);



// //     const formDataToSend = new FormData();
// //     Object.keys(formData).forEach((key) => {
// //         if (key === "category" && Array.isArray(formData[key])) {
// //             formDataToSend.append(key, formData[key].join(","));
// //         } else if (formData[key] instanceof File) {
// //             formDataToSend.append(key, formData[key]);
// //         } else {
// //             formDataToSend.append(key, formData[key]);
// //         }
// //     });

// //     try {
// //         let uploadedImage1 = "";
// //         let uploadedImage2 = "";

// //         // Upload images to external API
// //         if (formData.image1 || formData.image2) {
// //             const uploadData = new FormData();
// //             uploadData.append("action", "img_upload");
// //             uploadData.append("user_id", formData.user_id); // Add user_id here
// //             if (formData.image1) uploadData.append("image", formData.image1);
// //             if (formData.image2) uploadData.append("other_image", formData.image2);

// //             const uploadResponse = await axios.post("https://nithra.mobi/calendar/services/api/img_upload.php", uploadData, {
// //                 headers: { "Content-Type": "multipart/form-data" },
// //             });

// //             console.log("Upload Response:", uploadResponse.data);

// //             if (uploadResponse.status === 200 && uploadResponse.data) {
// //                 uploadedImage1 = uploadResponse.data.image_url || "";
// //                 uploadedImage2 = uploadResponse.data.other_image_url || "";
// //             }
// //         }

// //         // Add uploaded image URLs to form data
// //         formDataToSend.append("image1", uploadedImage1);
// //         formDataToSend.append("image2", uploadedImage2);

// //         // Log final form data
// //         for (let pair of formDataToSend.entries()) {
// //             console.log(pair[0] + ', ' + pair[1]);
// //         }

// //         // Check if the user already exists
// //         const searchResponse = await fetch(`${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${formData.type}`);
// //     const searchData = await searchResponse.json(); // Get the response data


// //     console.log("Search Response Data:", searchData); // Log the response data


// //         if (searchResponse.ok) {
// //             // User exists, ask for confirmation to update
// //             const confirmUpdate = window.confirm(`Do you want to update the user with ID: ${formData.user_id}?`);

// //             if (confirmUpdate) {
// //                 // User confirmed, perform update
// //                 const updateResponse = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
// //                     headers: { "Content-Type": "multipart/form-data" },
// //                 });

// //                 if (updateResponse.status === 200) {
// //                     alert("User updated successfully!");
// //                     window.location.reload();
// //                 }
// //             } else {
// //                 // User canceled the update
// //                 alert("Update canceled.");
// //             }
// //         } else {
// //             // User does not exist, perform insert
// //             const insertResponse = await axios.post(`${API_BASE_URL}/register_newuser`, formDataToSend, {
// //                 headers: { "Content-Type": "multipart/form-data" },
// //             });

// //             if (insertResponse.status === 200) {
// //                 alert("Registration successful!");
// //                 window.location.reload();
// //             }
// //         }
// //     } catch (err) {
// //         console.error("Error submitting form:", err);
// //         alert("An error occurred. Please try again.");
// //     }
// // };


// // const handleSubmit = async (e) => {
// //   e.preventDefault();

// //   console.log("Form Data Before Submission:", formData);

// //   const formDataToSend = new FormData();
// //   Object.keys(formData).forEach((key) => {
// //       if (key === "category" && Array.isArray(formData[key])) {
// //           formDataToSend.append(key, formData[key].join(","));
// //       } else if (formData[key] instanceof File) {
// //           formDataToSend.append(key, formData[key]);
// //       } else {
// //           formDataToSend.append(key, formData[key]);
// //       }
// //   });

// //   try {
// //       let uploadedImage1 = "";
// //       let uploadedImage2 = "";

// //       // Upload images to external API
// //       if (formData.image1 || formData.image2) {
// //           const uploadData = new FormData();
// //           uploadData.append("action", "img_upload");
// //           uploadData.append("user_id", formData.user_id || ""); // Ensure it's defined

// //           if (formData.image1) uploadData.append("image", formData.image1);
// //           if (formData.image2) uploadData.append("other_image", formData.image2);

// //           const uploadResponse = await axios.post("https://nithra.mobi/calendar/services/api/img_upload.php", uploadData, {
// //               headers: { "Content-Type": "multipart/form-data" },
// //           });

// //           console.log("Upload Response:", uploadResponse.data);

// //           if (uploadResponse.status === 200 && uploadResponse.data) {
// //               uploadedImage1 = uploadResponse.data.image_url || "";
// //               uploadedImage2 = uploadResponse.data.other_image_url || "";
// //           }
// //       }

// //       // Add uploaded image URLs to form data
// //       formDataToSend.append("image1", uploadedImage1);
// //       formDataToSend.append("image2", uploadedImage2);

// //       // Check if the user already exists
// //       const searchResponse = await fetch(`${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${formData.type}`);
// //       const searchData = await searchResponse.json();

// //       console.log("Search Response Data:", searchData);

// //       if (searchResponse.ok && searchData.id) {
// //           formData.user_id = searchData.id; // Assign user_id from API response
// //           formDataToSend.append("user_id", formData.user_id); // Include in formDataToSend

// //           console.log("User ID found:", formData.user_id);

// //           const confirmUpdate = window.confirm(`Do you want to update the user with ID: ${formData.user_id}?`);

// //           if (confirmUpdate) {
// //               const updateResponse = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
// //                   headers: { "Content-Type": "multipart/form-data" },
// //               });

// //               if (updateResponse.status === 200) {
// //                   alert("User updated successfully!");
// //                   window.location.reload();
// //               }
// //           } else {
// //               alert("Update canceled.");
// //           }
// //       } else {
// //           console.log("User not found, proceeding with registration.");

// //           // Register a new user
// //           const insertResponse = await axios.post(`${API_BASE_URL}/register_newuser`, formDataToSend, {
// //               headers: { "Content-Type": "multipart/form-data" },
// //           });

// //           if (insertResponse.status === 200) {
// //               alert("Registration successful!");
// //               window.location.reload();
// //           }
// //       }
// //   } catch (err) {
// //       console.error("Error submitting form:", err);
// //       alert("An error occurred. Please try again.");
// //   }
// // };

// const handleSubmit = async (e) => {
//   e.preventDefault();

//   console.log("Form Data Before Submission:", formData);

//   // Prepare the data to send
//   const formDataToSend = new FormData();
//   Object.keys(formData).forEach((key) => {
//       if (key === "category" && Array.isArray(formData[key])) {
//           formDataToSend.append(key, formData[key].join(","));
//       } else if (formData[key] instanceof File) {
//           formDataToSend.append(key, formData[key]);
//       } else {
//           formDataToSend.append(key, formData[key]);
//       }
//   });

//   try {
//       // **First, search for the user to obtain the user_id**
//       const searchResponse = await fetch(`${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${formData.type}`);
//       const searchData = await searchResponse.json();

//       if (searchResponse.ok && searchData.id) {
//           // User exists, so assign the user_id
//           formData.user_id = searchData.id;
//           formDataToSend.append("user_id", formData.user_id);
//       } else {
//           // If the user doesn't exist, you might want to register the user first.
//           // For example:
//           const insertResponse = await axios.post(`${API_BASE_URL}/register_newuser`, formDataToSend, {
//               headers: { "Content-Type": "multipart/form-data" },
//           });
//           if (insertResponse.status === 200) {
//               // Assuming the registration response returns the new user_id
//               formData.user_id = insertResponse.data.user_id;
//               formDataToSend.append("user_id", formData.user_id);
//           }
//       }

//       // **Now that you have a valid user_id, proceed with the image upload**
//       let uploadedImage1 = "";
//       let uploadedImage2 = "";

//       if (formData.image1 || formData.image2) {
//           const uploadData = new FormData();
//           uploadData.append("action", "img_upload");
//           uploadData.append("user_id", formData.user_id || "");

//           if (formData.image1) uploadData.append("image", formData.image1);
//           if (formData.image2) uploadData.append("other_image", formData.image2);

//           const uploadResponse = await axios.post("https://nithra.mobi/calendar/services/api/img_upload.php", uploadData, {
//               headers: { "Content-Type": "multipart/form-data" },
//           });

//           console.log("Upload Response:", uploadResponse.data);
//           if (uploadResponse.status === 200 && uploadResponse.data) {
//               uploadedImage1 = uploadResponse.data.image_url || "";
//               uploadedImage2 = uploadResponse.data.other_image_url || "";
//           }
//       }

//       // Append the image URLs after upload
//       formDataToSend.append("image1", uploadedImage1);
//       formDataToSend.append("image2", uploadedImage2);

//       // **Finally, either update or insert based on user existence**
//       if (formData.user_id) {
//           // If user existed and you want to update:
//           const confirmUpdate = window.confirm(`Do you want to update the user with ID: ${formData.user_id}?`);
//           if (confirmUpdate) {
//               const updateResponse = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
//                   headers: { "Content-Type": "multipart/form-data" },
//               });
//               if (updateResponse.status === 200) {
//                   alert("User updated successfully!");
//                   window.location.reload();
//               }
//           } else {
//               alert("Update canceled.");
//           }
//       } else {
//           // If no user_id was found (or after registration)
//           const insertResponse = await axios.post(`${API_BASE_URL}/register_newuser`, formDataToSend, {
//               headers: { "Content-Type": "multipart/form-data" },
//           });
//           if (insertResponse.status === 200) {
//               alert("Registration successful!");
//               window.location.reload();
//           }
//       }
//   } catch (err) {
//       console.error("Error submitting form:", err);
//       alert("An error occurred. Please try again.");
//   }
// };
    
    
     
//       const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//       };
    
//       // Handle category selection
//       const handleCategoryChange = (selectedOptions) => {
//         setFormData({
//           ...formData,
//           category: selectedOptions.map((option) => option.value),
//         });
//       };
    
//       return (
//         <div className="bg-gray-100 min-h-screen p-6">
//           <div className="max-w-4xl mx-auto">
//             {/* Search Form */}
//             <div className="bg-blue-900 text-gray p-6 rounded-lg">
//               <h2 className="text-lg font-semibold mb-4 text-white">Search Form</h2>
//               <form onSubmit={handleSearch} className="grid grid-cols-1 md:grid-cols-3 gap-4">
//     <div>
//         <label htmlFor="search-mobile" className="block text-sm text-white">
//             Mobile No<span className="text-red-500">*</span>
//         </label>
//         <input
//             type="text"
//             id="search-mobile"
//             name="searchMobile" // Add name attribute
//             className="w-full p-2 border rounded"
//             placeholder="Enter mobile number"
//             required
//         />
//     </div>
//     <div>
//         <label htmlFor="search-type" className="block text-sm text-white">
//             Type<span className="text-red-500">*</span>
//         </label>
//         <select id="search-type" name="searchType" className="w-full p-2 border rounded" required>
//             <option value="">Select Type</option>
//             <option value="ஜோதிடர்">ஜோதிடர்</option>
//             <option value="ஐயர்">ஐயர்</option>
//             <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
//             <option value="எண்கணிதம்">எண்கணிதம்</option>
//             <option value="சிற்பி">சிற்பி</option>
//             <option value="விபூதி தயாரிப்பவர்">விபூதி தயாரிப்பவர்</option>
//             <option value="ஆன்மீக சொற்பொழிவாளர்">ஆன்மீக சொற்பொழிவாளர்</option>
//             <option value="திருவிழா அலங்காரம் செய்பவர்">திருவிழா அலங்காரம் செய்பவர்</option>
//             <option value="சிற்பி / ஸ்தபதி">சிற்பி / ஸ்தபதி</option>
//             <option value="அலங்காரம் செய்பவர்">அலங்காரம் செய்பவர்</option>
//         </select>
//     </div>
//     <div className="flex items-end">
//         <button
//             type="submit"
//             className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//         >
//             Search
//         </button>
//     </div>
// </form>
//             </div>
      
//             {/* Registration Form */}
//             <div className="bg-white p-6 mt-8 rounded-lg shadow-md">
//               <h2 className="text-lg font-semibold mb-6">Registration Form</h2>
//               <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 {/* Name */}
//                 <div>
//                   <label htmlFor="name" className="block text-sm">
//                     Name<span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     placeholder="Enter your name"
//                     required
//                   />
//                 </div>
      
//                 {/* Mobile No */}
//                 <div>
//                   <label htmlFor="mobile" className="block text-sm">
//                     Mobile No<span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="mobile"
//                     name="mobile"
//                     value={formData.mobile}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     placeholder="Enter mobile number"
//                     required
//                   />
//                 </div>
      
//                 {/* Gender */}
//                 <div>
//                   <label htmlFor="gender" className="block text-sm">
//                     Gender<span className="text-red-500">*</span>
//                   </label>
//                   <div className="flex gap-4 mt-2">
//                     <label className="flex items-center">
//                       <input
//                         type="radio"
//                         name="gender"
//                         value="ஆண்"
//                         checked={formData.gender === "ஆண்"}
//                         onChange={handleChange}
//                         required
//                       />
//                       <span className="ml-2">ஆண்</span>
//                     </label>
//                     <label className="flex items-center">
//                       <input
//                         type="radio"
//                         name="gender"
//                         value="பெண்"
//                         checked={formData.gender === "பெண்"}
//                         onChange={handleChange}
//                         required
//                       />
//                       <span className="ml-2">பெண்</span>
//                     </label>
//                   </div>
//                 </div>
      
//                 {/* Type */}
//                 <div>
//                   <label htmlFor="type" className="block text-sm">
//                     Type<span className="text-red-500">*</span>
//                   </label>
//                   <select
//                     name="type"
//                     value={formData.type}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     required
//                   >
//                     <option value="">Select Type</option>
//                     <option value="ஜோதிடர்">ஜோதிடர்</option>
//                     <option value="ஐயர்">ஐயர்</option>
//                     <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
//                     <option value="எண்கணிதம்">எண்கணிதம்</option>
//                     <option value="சிற்பி">சிற்பி</option>
//                     <option value="விபூதி தயாரிப்பவர்">விபூதி தயாரிப்பவர்</option>
//                     <option value="ஆன்மீக சொற்பொழிவாளர்">ஆன்மீக சொற்பொழிவாளர்</option>
//                     <option value="திருவிழா அலங்காரம் செய்பவர்">
//                       திருவிழா அலங்காரம் செய்பவர்
//                     </option>
//                     <option value="சிற்பி / ஸ்தபதி">சிற்பி / ஸ்தபதி</option>
//                     <option value="அலங்காரம் செய்பவர்">அலங்காரம் செய்பவர்</option>
//                   </select>
//                 </div>
      
//                 {/* Category */}
//                 <div>
//                   <label htmlFor="category" className="block text-sm">
//                     Category<span className="text-red-500"></span>
//                   </label>
//                   <Select
//                     isMulti
//                     options={categories}
//                     value={categories.filter((cat) =>
//                       formData.category.includes(cat.value)
//                     )}
//                     onChange={handleCategoryChange}
//                     className="w-full"
//                     placeholder="Select categories"
//                     isLoading={loading.categories}
                    
//                   />
//                 </div>
      
//                 <div>
//     <label className="block text-sm">Is Education</label>
//     <div className="flex gap-4">
//         <label>
//             <input
//                 type="radio"
//                 name="isEducation"
//                 value="1"
//                 onChange={handleChange}
//                 checked={formData.isEducation === "1"}
//             />
//             Yes
//         </label>
//         <label>
//             <input
//                 type="radio"
//                 name="isEducation"
//                 value="2"
//                 onChange={handleChange}
//                 checked={formData.isEducation === "2"}
//             />
//             No
//         </label>
//         <label>
//             {/* <input
//                 type="radio"
//                 name="isEducation"
//                 value="0"
//                 onChange={handleChange}
//                 checked={formData.isEducation === "0"}
//             /> */}
//             {/* No Selection */}
//         </label>
//     </div>
// </div>


// {/* Show Education field only when isEducation is '1' */}
// {formData.isEducation === "1" && (
//     <div>
//         <label htmlFor="education" className="block text-sm">
//             Education
//         </label>
//         <input
//             type="text"
//             id="education"
//             name="education"
//             value={formData.education}
//             onChange={handleChange}
//             className="w-full p-2 border rounded"
//             placeholder="Enter Education"
//             required
//         />
//     </div>
// )}
//                 {/* Experience */}
//                 <div>
//                   <label htmlFor="experience" className="block text-sm">
//                     Experience<span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     id="experience"
//                     name="experience"
//                     value={formData.experience}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     placeholder="Enter experience"
//                     required
//                   />
//                 </div>
      
//                 {/* Email */}
//                 <div>
//                   <label htmlFor="email" className="block text-sm">
//                     Email
//                   </label>
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     placeholder="Enter email"
//                   />
//                 </div>
      
//                 {/* Door Number */}
//                 <div>
//                   <label className="block text-sm">Door Number</label>
//                   <input
//                     type="text"
//                     name="doorNumber"
//                     value={formData.doorNumber}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   />
//                 </div>
      
//                 {/* Street */}
//                 <div>
//                   <label htmlFor="street" className="block text-sm">
//                     Street
//                   </label>
//                   <input
//                     type="text"
//                     id="street"
//                     name="street"
//                     value={formData.street}
//                     onChange={handleChange}
//                     className="w-full p-2 border rounded"
//                     placeholder="Enter street"
//                   />
//                 </div>
      
//                 {/* Place */}
//                 <div>
//                   <label className="block text-sm">Place</label>
//                   <input
//                     type="text"
//                     name="place"
//                     value={formData.place}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   />
//                 </div>
      
//                 {/* District */}
//                 <div>
//                   <label htmlFor="district" className="block text-sm">
//                     District<span className="text-red-500">*</span>
//                   </label>
//                   <select
//                     name="district"
//                     value={formData.district}
//                     onChange={handleDistrictChange}
//                     className="w-full p-2 border rounded"
//                     required
//                   >
//                     <option value="">Select District</option>
//                     {districts.map((district) => (
//                       <option key={district.id} value={district.id}>
//                         {district.tamil}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
      
//                 {/* City */}
//           {/* City */}
// <div>
//     <label htmlFor="city" className="block text-sm">
//         City<span className="text-red-500">*</span>
//     </label>
//     <select
//         name="city"
//         value={formData.city}
//         onChange={handleChange}
//         className="w-full p-2 border rounded"
//         disabled={loading.cities}
//         required
//     >
//         <option value="">Select City</option>
//         {cities.map((city) => (
//             <option key={city.id} value={city.id}>
//                 {city.tamil}
//             </option>
//         ))}
//     </select>
// </div>
      
//                 {/* Pincode */}
//                 <div>
//                   <label className="block text-sm">Pincode<span className="text-red-500">*</span></label>
//                   <input
//                     type="text"
//                     name="pincode"
//                     value={formData.pincode}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                     required
//                   />
//                 </div>
      
//                 {/* Other Details */}
//                 <div>
//                   <label className="block text-sm">Other Details</label>
//                   <textarea
//                     name="otherDetails"
//                     value={formData.otherDetails}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   ></textarea>
//                 </div>
      
//                 {/* Web Links */}
//                 <div>
//                   <label className="block text-sm">Web Links</label>
//                   <input
//                     type="text"
//                     name="webLinks"
//                     value={formData.webLinks}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   />
//                 </div>
      
//                 {/* YouTube Links */}
//                 <div>
//                   <label className="block text-sm">YouTube Links</label>
//                   <input
//                     type="text"
//                     name="youtubeLinks"
//                     value={formData.youtubeLinks}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   />
//                 </div>
      
//                 {/* Facebook Links */}
//                 <div>
//                   <label className="block text-sm">Facebook Links</label>
//                   <input
//                     type="text"
//                     name="facebookLinks"
//                     value={formData.facebookLinks}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   />
//                 </div>
      
//                 {/* DND */}
//                 <div>
//                   <label className="block text-sm">DND</label>
//                   <select
//                     name="dnd"
//                     value={formData.dnd}
//                     onChange={handleChange}
//                     className="w-full border rounded p-2"
//                   >
//                     <option value="">Show all</option>
//                     <option value="Yes">Yes</option>
//                     <option value="No">No</option>
//                   </select>
//                 </div>
      
//                 {/* Image 1 Upload */}
//                 <div>
//                   <label className="block text-sm">Image 1 Upload</label>
//                   <input
//                     type="file"
//                     name="image1"
//                     onChange={handleFileChange}
//                     className="w-full border rounded p-2"
//                   />
//                   {formData.image1 && (
//                   <img
//                 //   src={`http://localhost:3036/uploads/${formData.image1}`}
//                   src={formData.image1}
//                   alt="Image 1"
//                   className="w-40 h-40 object-cover"
//               />
//                   )}
//                 </div>
      
//                 {/* Image 2 Upload */}
//                 <div>
//                   <label className="block text-sm">Image 2 Upload</label>
//                   <input
//                     type="file"
//                     name="image2"
//                     onChange={handleFileChange}
//                     className="w-full border rounded p-2"
//                   />
//                   {formData.image2 && (
//                     <img
//                     // src={`http://localhost:3036/uploads/${formData.image2}`}
//                     src={formData.image2}
//                     alt=""
//                       className="mt-2 h-20 w-20 rounded border"
//                     />
//                   )}
//                 </div>
      
//                 {/* ID Proof Upload */}
//                 <div>
//                   <label className="block text-sm">ID Proof</label>
//                   <input
//                     type="file"
//                     name="idProof"
//                     onChange={handleFileChange}
//                     className="w-full border rounded p-2"
//                   />
//                   {formData.idProof && (
//                     <img
//                 //   src={`http://localhost:3036/uploads/${formData.idProof}`}
//                 src={formData.idProof}

//                       alt=""
//                       className="mt-2 h-20 w-20 rounded border"
//                     />
//                   )}
//                 </div>
//                 {/* Address Proof Upload */}
//                 <div>
//                   <label className="block text-sm">Address Proof</label>
//                   <input
//                     type="file"
//                     name="addressProof"
//                     onChange={handleFileChange}
//                     className="w-full border rounded p-2"
//                   />
//                   {formData.addressProof && (
//                     <img
//                     // src={`http://localhost:3036/uploads/${formData.addressProof}`}
//                     src={formData.addressProof}

//                       alt=""
//                       className="mt-2 h-20 w-20 rounded border"
//                     />
//                   )}
//                 </div>
      
//                 {/* Other Proof Upload */}
//                 <div>
//                   <label className="block text-sm">Other Proof</label>
//                   <input
//                     type="file"
//                     name="otherProof"
//                     onChange={handleFileChange}
//                     className="w-full border rounded p-2"
//                   />
//                   {formData.otherProof && (
//                     <img
//                     // src={`http://localhost:3036/uploads/${formData.otherProof}`}
//                     src={formData.otherProof}

//                       alt="Other Proof"
//                       className="mt-2 h-20 w-20 rounded border"
//                     />
//                   )}
//                 </div>
      
//                 {/* Submit Button */}
//                 <div className="mt-6 flex justify-end">
//                   <button
//                     type="submit"
//                     className="bg-blue-600 text-white px-4 py-2 rounded"
//                   >
//                     Save
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       );};

// export default RegistrationFormnew;








import React, { useState, useEffect } from "react";
import axios from 'axios';
import Select from "react-select";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const RegistrationFormnew = () => {

    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        altermobile:"",
        gender: "",
        type: "",
        category: [],
        isEducation: "0", // Default to 0 (No selection)
        education: "",
        experience: "",
        email: "",
        doorNumber: "",
        street: "",
        place: "",
        district: "",
        city: "",
        pincode: "",
        otherDetails: "",
        webLinks: "",
        youtubeLinks: "",
        facebookLinks: "",
        dnd: "",
        image1: "",
        image2: "",
        idProof: "",
        addressProof: "",
        otherProof: "",
      });
    
      const [categories, setCategories] = useState([]);
      const [districts, setDistricts] = useState([]);
      const [cities, setCities] = useState([]);
      const [loading, setLoading] = useState({ categories: false, cities: false });
      const [searchData, setSearchData] = useState(null);
      
    
      // Fetch categories based on selected type
      useEffect(() => {
        const fetchCategoriesByType = async () => {
          if (!formData.type) {
            setCategories([]);
            return;
          }
          setLoading((prev) => ({ ...prev, categories: true }));
          try {
            const response = await fetch(`${API_BASE_URL}/categories?type=${formData.type}`);
            if (response.ok) {
              const data = await response.json();
              setCategories(
                data.map((item) => ({
                  value: item.id,
                  label: item.category,
                }))
              );
            } else {
              console.error("Failed to fetch categories");
            }
          } catch (err) {
            console.error("Error fetching categories:", err);
          } finally {
            setLoading((prev) => ({ ...prev, categories: false }));
          }
        };
        fetchCategoriesByType();
      }, [formData.type]);
    
      // Fetch districts
      useEffect(() => {
        const fetchDistricts = async () => {
          try {
            const response = await fetch(`${API_BASE_URL}/districts`);
            if (response.ok) {
              const data = await response.json();
              setDistricts(data);
            } else {
              console.error("Failed to fetch districts");
            }
          } catch (err) {
            console.error("Error fetching districts:", err);
          }
        };
        fetchDistricts();
      }, []);
    


       // Handle file uploads
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({ ...formData, [name]: files[0] });
  };


  const handleSearch = async (e) => {
    e.preventDefault();
    const mobile = e.target.searchMobile.value; // Get mobile number from the input
    const type = e.target.searchType.value; // Get type from the select

    if (!mobile || !type) {
        alert("Please enter both mobile number and type.");
        return;
    }

    try {
        const response = await fetch(`${API_BASE_URL}/search_user_new?mobile=${mobile}&type=${type}`);
        if (response.ok) {
            const data = await response.json();
            setSearchData(data); // Set the fetched data to state

            // Fetch the cities based on the district ID
            const cityResponse = await fetch(`${API_BASE_URL}/cities?districtId=${data.district}`);
            if (cityResponse.ok) {
                const cities = await cityResponse.json();
                const selectedCity = cities.find(city => city.id === data.city); // Find the city by ID

                setFormData({
                    name: data.name,
                    mobile: data.mobileno,
                    altermobile:data.altermobile,
                    gender: data.gender,
                    type: data.type,
                    category: data.category,
                    isEducation: data.is_education.toString(), // Convert to string if needed
                    education: data.education,
                    experience: data.experience,
                    email: data.email,
                    doorNumber: data.door_no,
                    street: data.street,
                    place: data.place_name,
                    district: data.district,
                    city: selectedCity ? selectedCity.id : "", // Set the city ID
                    pincode: data.pincode,
                    otherDetails: data.other_details,
                    webLinks: data.web_links,
                    youtubeLinks: data.youtube_links,
                    facebookLinks: data.fb_links,
                    dnd: data.is_dnd ? "Yes" : "No", // Convert to string if needed
                    image1: data.photo, // Set the image path
                    image2: data.other_photo, // Set the other image path
                    idProof: data.id_proof, // Set the ID proof path
                    addressProof: data.address_proof, // Set the address proof path
                    otherProof: data.other_proof, // Set the other proof path
                });

                // Set the cities in state to populate the dropdown
                setCities(cities);
            } else {
                console.error("Failed to fetch cities");
            }
        } else {
            console.error("Failed to fetch user data");
            alert("No user found with this mobile number and type.");
        }
    } catch (err) {
        console.error("Error fetching user data:", err);
        alert("An error occurred while fetching user data.");
    }
};

      // Fetch cities based on district
      const handleDistrictChange = async (e) => {
        const districtId = e.target.value;
        setFormData({ ...formData, district: districtId, city: "" });
        setLoading((prev) => ({ ...prev, cities: true }));
    
        try {
          const response = await fetch(`${API_BASE_URL}/cities?districtId=${districtId}`);
          if (response.ok) {
            const data = await response.json();
            setCities(data);
          } else {
            console.error("Failed to fetch cities");
          }
        } catch (err) {
          console.error("Error fetching cities:", err);
        } finally {
          setLoading((prev) => ({ ...prev, cities: false }));
        }
      };


    //   const handleSubmit = async (e) => {
    //     e.preventDefault();
    
    //     const formDataToSend = new FormData();
    //     Object.keys(formData).forEach((key) => {
    //         if (key === "category") {
    //             // Check if formData.category is an array before calling join
    //             if (Array.isArray(formData[key])) {
    //                 formDataToSend.append(key, formData[key].join(","));
    //             } else {
    //                 // If it's not an array, handle it accordingly (e.g., set it to an empty string)
    //                 formDataToSend.append(key, "");
    //             }
    //         } else if (formData[key] instanceof File) {
    //             formDataToSend.append(key, formData[key]);
    //         } else {
    //             formDataToSend.append(key, formData[key]);
    //         }
    //     });
    
    //     try {
    //         // Check if the user already exists
    //         const searchResponse = await fetch(`${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${formData.type}`);
            
    //         if (searchResponse.ok) {
    //             // User exists, perform update
    //             const updateResponse = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
    //                 headers: { "Content-Type": "multipart/form-data" },
    //             });
    
    //             if (updateResponse.status === 200) {
    //                 alert("User  updated successfully!");
    //                 window.location.reload();
    //             }
    //         } else {
    //             // User does not exist, perform insert
    //             const insertResponse = await axios.post(`${API_BASE_URL}/register_newuser`, formDataToSend, {
    //                 headers: { "Content-Type": "multipart/form-data" },
    //             });
    
    //             if (insertResponse.status === 200) {
    //                 alert("Registration successful!");
    //                 window.location.reload();
    //             }
    //         }
    //     } catch (err) {
    //         console.error("Error submitting form:", err);
    //         if (err.response && err.response.status === 400) {
    //             alert("User  with this mobile number and type already exists!");
    //         } else {
    //             alert("An error occurred. Please try again.");
    //         }
    //     }
    // };
    
    
      // Handle form input changes
     
     
     
    //   const handleSubmit = async (e) => {
    //     e.preventDefault();
    
    //     const formDataToSend = new FormData();
    //     Object.keys(formData).forEach((key) => {
    //         if (key === "category" && Array.isArray(formData[key])) {
    //             formDataToSend.append(key, formData[key].join(","));
    //         } else if (formData[key] instanceof File) {
    //             formDataToSend.append(key, formData[key]);
    //         } else {
    //             formDataToSend.append(key, formData[key]);
    //         }
    //     });
    
    //     try {
    //         let uploadedImage1 = "";
    //         let uploadedImage2 = "";
    
    //         // Upload images to external API
    //         if (formData.image1 || formData.image2) {
    //             const uploadData = new FormData();
    //             uploadData.append("action", "img_upload");
    //             if (formData.image1) uploadData.append("image", formData.image1);
    //             if (formData.image2) uploadData.append("other_image", formData.image2);
    
    //             const uploadResponse = await axios.post("https://nithra.mobi/calendar/services/api/img_upload.php", uploadData, {
    //                 headers: { "Content-Type": "multipart/form-data" },
    //             });
    
    //             if (uploadResponse.status === 200 && uploadResponse.data) {
    //                 uploadedImage1 = uploadResponse.data.image_url || "";
    //                 uploadedImage2 = uploadResponse.data.other_image_url || "";
    //             }
    //         }
    
    //         // Add uploaded image URLs to form data
    //         formDataToSend.append("image1", uploadedImage1);
    //         formDataToSend.append("image2", uploadedImage2);
    
    //         // Check if the user already exists
    //         const searchResponse = await fetch(`${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${formData.type}`);
    
    //         if (searchResponse.ok) {
    //             // User exists, perform update
    //             const updateResponse = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
    //                 headers: { "Content-Type": "multipart/form-data" },
    //             });
    
    //             if (updateResponse.status === 200) {
    //                 alert("User updated successfully!");
    //                 window.location.reload();
    //             }
    //         } else {
    //             // User does not exist, perform insert
    //             const insertResponse = await axios.post(`${API_BASE_URL}/register_newuser`, formDataToSend, {
    //                 headers: { "Content-Type": "multipart/form-data" },
    //             });
    
    //             if (insertResponse.status === 200) {
    //                 alert("Registration successful!");
    //                 window.location.reload();
    //             }
    //         }
    //     } catch (err) {
    //         console.error("Error submitting form:", err);
    //         alert("An error occurred. Please try again.");
    //     }
    // };


  //   const handleSubmit = async (e) => {
  //     e.preventDefault();
  
  //     const formDataToSend = new FormData();
  //     Object.keys(formData).forEach((key) => {
  //         if (key === "category" && Array.isArray(formData[key])) {
  //             formDataToSend.append(key, formData[key].join(","));
  //         } else if (formData[key] instanceof File) {
  //             formDataToSend.append(key, formData[key]);
  //         } else {
  //             formDataToSend.append(key, formData[key]);
  //         }
  //     });
  
  //     try {
  //         let uploadedImage1 = "";
  //         let uploadedImage2 = "";
  
  //         // Upload images to external API
  //         if (formData.image1 || formData.image2) {
  //             const uploadData = new FormData();
  //             uploadData.append("action", "img_upload");
  //             if (formData.image1) uploadData.append("image", formData.image1);
  //             if (formData.image2) uploadData.append("other_image", formData.image2);
  
  //             const uploadResponse = await axios.post("https://nithra.mobi/calendar/services/api/img_upload.php", uploadData, {
  //                 headers: { "Content-Type": "multipart/form-data" },
  //             });
  
  //             console.log("Upload Response:", uploadResponse.data);
  
  //             if (uploadResponse.status === 200 && uploadResponse.data) {
  //                 uploadedImage1 = uploadResponse.data.image_url || "";
  //                 uploadedImage2 = uploadResponse.data.other_image_url || "";
  //             }
  //         }
  
  //         // Add uploaded image URLs to form data
  //         formDataToSend.append("image1", uploadedImage1);
  //         formDataToSend.append("image2", uploadedImage2);
  
  //         // Log final form data
  //         for (let pair of formDataToSend.entries()) {
  //             console.log(pair[0] + ', ' + pair[1]);
  //         }
  
  //         // Check if the user already exists
  //         const searchResponse = await fetch(`${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${formData.type}`);
  
  //         if (searchResponse.ok) {
  //             // User exists, perform update
  //             const updateResponse = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
  //                 headers: { "Content-Type": "multipart/form-data" },
  //             });
  
  //             if (updateResponse.status === 200) {
  //                 alert("User updated successfully!");
  //                 window.location.reload();
  //             }
  //         } else {
  //             // User does not exist, perform insert
  //             const insertResponse = await axios.post(`${API_BASE_URL}/register_newuser`, formDataToSend, {
  //                 headers: { "Content-Type": "multipart/form-data" },
  //             });
  
  //             if (insertResponse.status === 200) {
  //                 alert("Registration successful!");
  //                 window.location.reload();
  //             }
  //         }
  //     } catch (err) {
  //         console.error("Error submitting form:", err);
  //         alert("An error occurred. Please try again.");
  //     }
  // };


//   const handleSubmit = async (e) => {
//     e.preventDefault();


//     // Log formData to check user_id
//     console.log("Form Data:", formData);



//     const formDataToSend = new FormData();
//     Object.keys(formData).forEach((key) => {
//         if (key === "category" && Array.isArray(formData[key])) {
//             formDataToSend.append(key, formData[key].join(","));
//         } else if (formData[key] instanceof File) {
//             formDataToSend.append(key, formData[key]);
//         } else {
//             formDataToSend.append(key, formData[key]);
//         }
//     });

//     try {
//         let uploadedImage1 = "";
//         let uploadedImage2 = "";

//         // Upload images to external API
//         if (formData.image1 || formData.image2) {
//             const uploadData = new FormData();
//             uploadData.append("action", "img_upload");
//             uploadData.append("user_id", formData.user_id); // Add user_id here
//             if (formData.image1) uploadData.append("image", formData.image1);
//             if (formData.image2) uploadData.append("other_image", formData.image2);

//             const uploadResponse = await axios.post("https://nithra.mobi/calendar/services/api/img_upload.php", uploadData, {
//                 headers: { "Content-Type": "multipart/form-data" },
//             });

//             console.log("Upload Response:", uploadResponse.data);

//             if (uploadResponse.status === 200 && uploadResponse.data) {
//                 uploadedImage1 = uploadResponse.data.image_url || "";
//                 uploadedImage2 = uploadResponse.data.other_image_url || "";
//             }
//         }

//         // Add uploaded image URLs to form data
//         formDataToSend.append("image1", uploadedImage1);
//         formDataToSend.append("image2", uploadedImage2);

//         // Log final form data
//         for (let pair of formDataToSend.entries()) {
//             console.log(pair[0] + ', ' + pair[1]);
//         }

//         // Check if the user already exists
//         const searchResponse = await fetch(`${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${formData.type}`);
//     const searchData = await searchResponse.json(); // Get the response data


//     console.log("Search Response Data:", searchData); // Log the response data


//         if (searchResponse.ok) {
//             // User exists, ask for confirmation to update
//             const confirmUpdate = window.confirm(`Do you want to update the user with ID: ${formData.user_id}?`);

//             if (confirmUpdate) {
//                 // User confirmed, perform update
//                 const updateResponse = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
//                     headers: { "Content-Type": "multipart/form-data" },
//                 });

//                 if (updateResponse.status === 200) {
//                     alert("User updated successfully!");
//                     window.location.reload();
//                 }
//             } else {
//                 // User canceled the update
//                 alert("Update canceled.");
//             }
//         } else {
//             // User does not exist, perform insert
//             const insertResponse = await axios.post(`${API_BASE_URL}/register_newuser`, formDataToSend, {
//                 headers: { "Content-Type": "multipart/form-data" },
//             });

//             if (insertResponse.status === 200) {
//                 alert("Registration successful!");
//                 window.location.reload();
//             }
//         }
//     } catch (err) {
//         console.error("Error submitting form:", err);
//         alert("An error occurred. Please try again.");
//     }
// };



// const handleSubmit = async (e) => {
//   e.preventDefault();

//   console.log("Form Data Before Submission:", formData);

//   const formDataToSend = new FormData();
//   Object.keys(formData).forEach((key) => {
//       if (key === "category" && Array.isArray(formData[key])) {
//           formDataToSend.append(key, formData[key].join(","));
//       } else if (formData[key] instanceof File) {
//           formDataToSend.append(key, formData[key]);
//       } else {
//           formDataToSend.append(key, formData[key]);
//       }
//   });

//   try {
//       let uploadedImage1 = "";
//       let uploadedImage2 = "";

//       // Upload images to external API
//       if (formData.image1 || formData.image2) {
//           const uploadData = new FormData();
//           uploadData.append("action", "img_upload");
//           uploadData.append("user_id", formData.user_id || ""); // Ensure it's defined

//           if (formData.image1) uploadData.append("image", formData.image1);
//           if (formData.image2) uploadData.append("other_image", formData.image2);

//           const uploadResponse = await axios.post("https://nithra.mobi/calendar/services/api/img_upload.php", uploadData, {
//               headers: { "Content-Type": "multipart/form-data" },
//           });

//           console.log("Upload Response:", uploadResponse.data);

//           if (uploadResponse.status === 200 && uploadResponse.data) {
//               uploadedImage1 = uploadResponse.data.image_url || "";
//               uploadedImage2 = uploadResponse.data.other_image_url || "";
//           }
//       }

//       // Add uploaded image URLs to form data
//       formDataToSend.append("image1", uploadedImage1);
//       formDataToSend.append("image2", uploadedImage2);

//       // Check if the user already exists
//       const searchResponse = await fetch(`${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${formData.type}`);
//       const searchData = await searchResponse.json();

//       console.log("Search Response Data:", searchData);

//       if (searchResponse.ok && searchData.id) {
//           formData.user_id = searchData.id; // Assign user_id from API response
//           formDataToSend.append("user_id", formData.user_id); // Include in formDataToSend

//           console.log("User ID found:", formData.user_id);

//           const confirmUpdate = window.confirm(`Do you want to update the user with ID: ${formData.user_id}?`);

//           if (confirmUpdate) {
//               const updateResponse = await axios.put(`${API_BASE_URL}/update_user_new`, formDataToSend, {
//                   headers: { "Content-Type": "multipart/form-data" },
//               });

//               if (updateResponse.status === 200) {
//                   alert("User updated successfully!");
//                   window.location.reload();
//               }
//           } else {
//               alert("Update canceled.");
//           }
//       } else {
//           console.log("User not found, proceeding with registration.");

//           // Register a new user
//           const insertResponse = await axios.post(`${API_BASE_URL}/register_newuser`, formDataToSend, {
//               headers: { "Content-Type": "multipart/form-data" },
//           });

//           if (insertResponse.status === 200) {
//               alert("Registration successful!");
//               window.location.reload();
//           }
//       }
//   } catch (err) {
//       console.error("Error submitting form:", err);
//       alert("An error occurred. Please try again.");
//   }
// };


// Updated handleSubmit – now we simply build the FormData and send it to the server.
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data Before Submission:", formData);

    // Build FormData without any pre-uploading of images
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "category" && Array.isArray(formData[key])) {
        formDataToSend.append(key, formData[key].join(","));
      } else if (formData[key] instanceof File) {
        formDataToSend.append(key, formData[key]);
      } else {
        formDataToSend.append(key, formData[key]);
      }
    });

    try {
      // First, check if the user already exists
      const searchResponse = await fetch(
        `${API_BASE_URL}/search_user_new?mobile=${formData.mobile}&type=${encodeURIComponent(
          formData.type
        )}`
      );
      const searchData = await searchResponse.json();
      console.log("Search Response Data:", searchData);

      if (searchResponse.ok && searchData.id) {
        // User exists – update flow
        formData.user_id = searchData.id;
        formDataToSend.append("user_id", formData.user_id);

        // const confirmUpdate = window.confirm(
        //   `Do you want to update the user with ID: ${formData.user_id}?`
        // );

        const confirmUpdate = window.confirm(
          `Do you want to update the user with ID: ${formData.user_id} (${formData.name}, ${formData.type})?`
        );
        
        if (confirmUpdate) {
          const updateResponse = await axios.put(
            `${API_BASE_URL}/update_user_new`,
            formDataToSend,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          if (updateResponse.status === 200) {
            alert("User updated successfully!");
            window.location.reload();
          }
        } else {
          alert("Update canceled.");
        }
      } else {
        // User not found – registration flow
        console.log("User not found, proceeding with registration.");
        const insertResponse = await axios.post(
          `${API_BASE_URL}/register_newuser`,
          formDataToSend,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (insertResponse.status === 200) {
          alert("Registration successful!");
          window.location.reload();
        }
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      alert("An error occurred. Please try again");
      

    }
  };

    
    
     
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
    
      // Handle category selection
      const handleCategoryChange = (selectedOptions) => {
        setFormData({
          ...formData,
          category: selectedOptions.map((option) => option.value),
        });
      };
    
      return (
        <div className="bg-gray-100 min-h-screen p-6">
          <div className="max-w-4xl mx-auto">
            {/* Search Form */}
            <div className="bg-blue-900 text-gray p-6 rounded-lg">
              <h2 className="text-lg font-semibold mb-4 text-white">Search Form</h2>
              <form onSubmit={handleSearch} className="grid grid-cols-1 md:grid-cols-3 gap-4">
    <div>
        <label htmlFor="search-mobile" className="block text-sm text-white">
            Mobile No<span className="text-red-500">*</span>
        </label>
        <input
            type="text"
            id="search-mobile"
            name="searchMobile" // Add name attribute
            className="w-full p-2 border rounded"
            placeholder="Enter mobile number"
            required
        />
    </div>
    <div>
        <label htmlFor="search-type" className="block text-sm text-white">
            Type<span className="text-red-500">*</span>
        </label>
        <select id="search-type" name="searchType" className="w-full p-2 border rounded" required>
            <option value="">Select Type</option>
            <option value="ஜோதிடர்">ஜோதிடர்</option>
            <option value="ஐயர்">ஐயர்</option>
            <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
            <option value="எண்கணிதம்">எண்கணிதம்</option>
            <option value="சிற்பி">சிற்பி</option>
            <option value="விபூதி தயாரிப்பவர்">விபூதி தயாரிப்பவர்</option>
            <option value="ஆன்மீக சொற்பொழிவாளர்">ஆன்மீக சொற்பொழிவாளர்</option>
            <option value="திருவிழா அலங்காரம் செய்பவர்">திருவிழா அலங்காரம் செய்பவர்</option>
            <option value="சிற்பி / ஸ்தபதி">சிற்பி / ஸ்தபதி</option>
            <option value="அலங்காரம் செய்பவர்">அலங்காரம் செய்பவர்</option>
        </select>
    </div>
    <div className="flex items-end">
        <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
            Search
        </button>
    </div>
</form>
            </div>
      
            {/* Registration Form */}
            <div className="bg-white p-6 mt-8 rounded-lg shadow-md">
              <h2 className="text-lg font-semibold mb-6">Registration Form</h2>
              <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Name */}
                <div>
                  <label htmlFor="name" className="block text-sm">
                    Name<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    placeholder="Enter your name"
                    required

                  />
                </div>
      
                {/* Mobile No */}
                <div>
                  <label htmlFor="mobile" className="block text-sm">
                    Mobile No<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="mobile"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    placeholder="Enter mobile number"
                    required
                    disabled={searchData?.id ? true : false}  // Disabled if details are fetched

                  />
                </div>

                <div>
                  <label htmlFor="mobile" className="block text-sm">
                    Alternate Mobile No
                  </label>
                  <input
                    type="text"
                    id="altermobile"
                    name="altermobile"
                    value={formData.altermobile}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    placeholder="Enter Alternate mobile number"
                    
                  />
                </div> 
                {/* Gender */}
                <div>
                  <label htmlFor="gender" className="block text-sm">
                    Gender<span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-4 mt-2">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="ஆண்"
                        checked={formData.gender === "ஆண்"}
                        onChange={handleChange}
                        required
                      />
                      <span className="ml-2">ஆண்</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="பெண்"
                        checked={formData.gender === "பெண்"}
                        onChange={handleChange}
                        required
                      />
                      <span className="ml-2">பெண்</span>
                    </label>
                  </div>
                </div>
      
                {/* Type */}
                <div>
                  <label htmlFor="type" className="block text-sm">
                    Type<span className="text-red-500">*</span>
                  </label>
                  <select
                    name="type"
                    value={formData.type}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    required
                    disabled={searchData?.id ? true : false}  // Disabled if details are fetched

                  >
                    <option value="">Select Type</option>
                    <option value="ஜோதிடர்">ஜோதிடர்</option>
                    <option value="ஐயர்">ஐயர்</option>
                    <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
                    <option value="எண்கணிதம்">எண்கணிதம்</option>
                    <option value="சிற்பி">சிற்பி</option>
                    <option value="விபூதி தயாரிப்பவர்">விபூதி தயாரிப்பவர்</option>
                    <option value="ஆன்மீக சொற்பொழிவாளர்">ஆன்மீக சொற்பொழிவாளர்</option>
                    <option value="திருவிழா அலங்காரம் செய்பவர்">
                      திருவிழா அலங்காரம் செய்பவர்
                    </option>
                    <option value="சிற்பி / ஸ்தபதி">சிற்பி / ஸ்தபதி</option>
                    <option value="அலங்காரம் செய்பவர்">அலங்காரம் செய்பவர்</option>
                  </select>
                </div>
      
                {/* Category */}
                <div>
                  <label htmlFor="category" className="block text-sm">
                    Category<span className="text-red-500"></span>
                  </label>
                  <Select
                    isMulti
                    options={categories}
                    value={categories.filter((cat) =>
                      formData.category.includes(cat.value)
                    )}
                    onChange={handleCategoryChange}
                    className="w-full"
                    placeholder="Select categories"
                    isLoading={loading.categories}
                    
                  />
                </div>
      
                <div>
    <label className="block text-sm">Is Education</label>
    <div className="flex gap-4">
        <label>
            <input
                type="radio"
                name="isEducation"
                value="1"
                onChange={handleChange}
                checked={formData.isEducation === "1"}
            />
            Yes
        </label>
        <label>
            <input
                type="radio"
                name="isEducation"
                value="2"
                onChange={handleChange}
                checked={formData.isEducation === "2"}
            />
            No
        </label>
        <label>
            {/* <input
                type="radio"
                name="isEducation"
                value="0"
                onChange={handleChange}
                checked={formData.isEducation === "0"}
            /> */}
            {/* No Selection */}
        </label>
    </div>
</div>


{/* Show Education field only when isEducation is '1' */}
{formData.isEducation === "1" && (
    <div>
        <label htmlFor="education" className="block text-sm">
            Education
        </label>
        <input
            type="text"
            id="education"
            name="education"
            value={formData.education}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Enter Education"
            required
        />
    </div>
)}
                {/* Experience */}
                <div>
                  <label htmlFor="experience" className="block text-sm">
                    Experience<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="experience"
                    name="experience"
                    value={formData.experience}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    placeholder="Enter experience"
                    required
                  />
                </div>
      
                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-sm">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    placeholder="Enter email"
                  />
                </div>
      
                {/* Door Number */}
                <div>
                  <label className="block text-sm">Door Number</label>
                  <input
                    type="text"
                    name="doorNumber"
                    value={formData.doorNumber}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  />
                </div>
      
                {/* Street */}
                <div>
                  <label htmlFor="street" className="block text-sm">
                    Street
                  </label>
                  <input
                    type="text"
                    id="street"
                    name="street"
                    value={formData.street}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    placeholder="Enter street"
                  />
                </div>
      
                {/* Place */}
                <div>
                  <label className="block text-sm">Place</label>
                  <input
                    type="text"
                    name="place"
                    value={formData.place}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  />
                </div>
      
                {/* District */}
                <div>
                  <label htmlFor="district" className="block text-sm">
                    District<span className="text-red-500">*</span>
                  </label>
                  <select
                    name="district"
                    value={formData.district}
                    onChange={handleDistrictChange}
                    className="w-full p-2 border rounded"
                    required
                  >
                    <option value="">Select District</option>
                    {districts.map((district) => (
                      <option key={district.id} value={district.id}>
                        {district.tamil}
                      </option>
                    ))}
                  </select>
                </div>
      
                {/* City */}
          {/* City */}
<div>
    <label htmlFor="city" className="block text-sm">
        City<span className="text-red-500">*</span>
    </label>
    <select
        name="city"
        value={formData.city}
        onChange={handleChange}
        className="w-full p-2 border rounded"
        disabled={loading.cities}
        required
    >
        <option value="">Select City</option>
        {cities.map((city) => (
            <option key={city.id} value={city.id}>
                {city.tamil}
            </option>
        ))}
    </select>
</div>
      
                {/* Pincode */}
                <div>
                  <label className="block text-sm">Pincode<span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                    required
                  />
                </div>
      
                {/* Other Details */}
                <div>
                  <label className="block text-sm">Other Details</label>
                  <textarea
                    name="otherDetails"
                    value={formData.otherDetails}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  ></textarea>
                </div>
      
                {/* Web Links */}
                <div>
                  <label className="block text-sm">Web Links</label>
                  <input
                    type="text"
                    name="webLinks"
                    value={formData.webLinks}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  />
                </div>
      
                {/* YouTube Links */}
                <div>
                  <label className="block text-sm">YouTube Links</label>
                  <input
                    type="text"
                    name="youtubeLinks"
                    value={formData.youtubeLinks}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  />
                </div>
      
                {/* Facebook Links */}
                <div>
                  <label className="block text-sm">Facebook Links</label>
                  <input
                    type="text"
                    name="facebookLinks"
                    value={formData.facebookLinks}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  />
                </div>
      
                {/* DND */}
                <div>
                  <label className="block text-sm">DND</label>
                  <select
                    name="dnd"
                    value={formData.dnd}
                    onChange={handleChange}
                    className="w-full border rounded p-2"
                  >
                    <option value="">Show all</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
      
                {/* Image 1 Upload */}
                <div>
                  <label className="block text-sm">Image 1 Upload</label>
                  <input
                    type="file"
                    name="image1"
                    onChange={handleFileChange}
                    className="w-full border rounded p-2"
                  />
                  {formData.image1 && (
                                    <img src={`${API_BASE_URL}/${formData.image1}`} alt="Image 1" className="w-40 h-40 object-cover" />

                  )}
                </div>
      
                {/* Image 2 Upload */}
                <div>
                  <label className="block text-sm">Image 2 Upload</label>
                  <input
                    type="file"
                    name="image2"
                    onChange={handleFileChange}
                    className="w-full border rounded p-2"
                  />
                  {formData.image2 && (
                                                              <img src={`${API_BASE_URL}/${formData.image2}`} alt="Image 2" className="w-40 h-40 object-cover" />

                  )}
                </div>
      
                {/* ID Proof Upload */}
                <div>
                  <label className="block text-sm">ID Proof</label>
                  <input
                    type="file"
                    name="idProof"
                    onChange={handleFileChange}
                    className="w-full border rounded p-2"
                  />
                  {formData.idProof && (
                    <img
                //   src={`http://localhost:3036/uploads/${formData.idProof}`}
                src={formData.idProof}

                      alt=""
                      className="mt-2 h-20 w-20 rounded border"
                    />
                  )}
                </div>
                {/* Address Proof Upload */}
                <div>
                  <label className="block text-sm">Address Proof</label>
                  <input
                    type="file"
                    name="addressProof"
                    onChange={handleFileChange}
                    className="w-full border rounded p-2"
                  />
                  {formData.addressProof && (
                    <img
                    // src={`http://localhost:3036/uploads/${formData.addressProof}`}
                    src={formData.addressProof}

                      alt=""
                      className="mt-2 h-20 w-20 rounded border"
                    />
                  )}
                </div>
      
                {/* Other Proof Upload */}
                <div>
                  <label className="block text-sm">Other Proof</label>
                  <input
                    type="file"
                    name="otherProof"
                    onChange={handleFileChange}
                    className="w-full border rounded p-2"
                  />
                  {formData.otherProof && (
                    <img
                    // src={`http://localhost:3036/uploads/${formData.otherProof}`}
                    src={formData.otherProof}

                      alt="Other Proof"
                      className="mt-2 h-20 w-20 rounded border"
                    />
                  )}
                </div>
      
                {/* Submit Button */}
                <div className="mt-6 flex justify-end">
                  <button
                    type="submit"
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      );};

export default RegistrationFormnew;